import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/properties",
    name: "Properties",
    component: () => import("@/views/Properties.vue"),
  },
  {
    path: "/propertieDetail",
    name: "PropertieDetail",
    component: () => import("@/views/PropertieDetail.vue"),
  },
  {
    path: "/menu",
    name: "Menu",
    component: () => import("@/views/Menu.vue"),
    meta: {
      hideFooter: true,
    },
  },
  {
    path: "/news/immigration",
    name: "Immigration",
    component: () => import("@/views/news/Immigration.vue"),
  },
  {
    path: "/news/education",
    name: "Education",
    component: () => import("@/views/news/Education.vue"),
  },
  {
    path: "/news/living",
    name: "Living",
    component: () => import("@/views/news/Living.vue"),
  },
  {
    path: "/news/knowledge",
    name: "Knowledge",
    component: () => import("@/views/news/Knowledge.vue"),
  },
  {
    path: "/news/immigrationDetail",
    name: "ImmigrationDetail",
    component: () => import("@/views/news/ImmigrationDetail.vue"),
  },
];

const router = new VueRouter({
  mode: "history", // 可选：去掉URL中的 `#`（需要服务器支持）
  routes,
});

export default router;
